import { Constants } from '../_constants/constants';
import { BaseParameterDto } from './base-parameter-dto';
export class LoginParameterDto extends BaseParameterDto {
    constructor() {
        super(...arguments);
        this.portalType = Constants.portalType;
    }
}
